module.exports = __webpack_public_path__ + "static/media/Past.9f134a04.webp";